require('./stateHooks');

import { LOAD_ASSETS } from '../../../redux-types/ui';

import { registerPrehook } from '../../../lib/reduxStateHooks';

import { applyTheme } from './theme';

applyTheme();

registerPrehook(LOAD_ASSETS, () => {
  return import(`./components`);
});
